import FpLoader from './FpLoader.jsx'
export default FpLoader
